// extracted by mini-css-extract-plugin
module.exports = {"button-with-spinner":"ButtonWithSpinner_button-with-spinner__2EdJ_","spinner":"ButtonWithSpinner_spinner__3ONuP"};